import { render, staticRenderFns } from "./Icon@.vue?vue&type=template&id=1c2392b7"
import script from "./Icon@.vue?vue&type=script&lang=js"
export * from "./Icon@.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports